import { logError } from "@entrilia/shared/logging";
import biApi from "../../../../../../api/biApi";
import type { DataSetDrillDownConfiguration } from "../types/drillDownConfigurationState.types";
import { createTypedAsyncThunk } from "../utils/createTypedAsyncThunk";

export const loadDrillDownConfiguration = createTypedAsyncThunk(
  "store/loadDrillDownConfiguration",
  async (_, { getState }) => {
    try {
      const response = await biApi.getDrillDownConfiguration();
      if (response.success && response.data) {
        return <DataSetDrillDownConfiguration>{
          drillDownConfiguration: response.data,
          dataSetId: getState().metaData.dataSetId,
        };
      } else {
        throw new Error("Failed to load drill down configuration");
      }
    } catch (error) {
      logError(error, "loadDrillDownConfiguration");
      throw new Error("Failed to load drill down configuration", { cause: error });
    }
  }
);
